export default {
	"BASE_URL": "https://dev-api.contestcrate.com/"
};